import { Badge } from '@amzn/awsui-components-core';
import { ContentRequestState } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';

interface Props {
  state: ContentRequestState;
}

const displayConfig = new Map<
  ContentRequestState,
  { color: 'blue' | 'grey' | 'green' | 'red'; displayName: string }
>([
  [ContentRequestState.REQUESTED, { color: 'grey', displayName: 'Requested' }],
  [ContentRequestState.ASSIGNED, { color: 'grey', displayName: 'Assigned' }],
  [ContentRequestState.ACCEPTED, { color: 'grey', displayName: 'Assignment accepted' }],
  [ContentRequestState.IN_PROGRESS, { color: 'blue', displayName: 'In Progress' }],
  [ContentRequestState.COMPLETED, { color: 'green', displayName: 'Completed' }],
  [ContentRequestState.DUPLICATED, { color: 'red', displayName: 'Duplicate' }],
  [ContentRequestState.REJECTED, { color: 'red', displayName: 'Rejected' }],
]);

const ContentRequestStateBadge = ({ state }: Props) => {
  if (!state) {
    return null;
  }

  const config = displayConfig.get(state) || { color: 'grey', displayName: 'Unknown' };
  return <Badge color={config.color} children={config.displayName} />;
};

export default ContentRequestStateBadge;
